<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑语音短信模板' : '新增语音短信模板'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="120px">
                    <el-form-item label="名称" prop="name" :error="errors.name">
                        <el-input v-model="form.name" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="平台模板编号" v-if="form.id">
                        <div>{{ form.id }}</div>
                    </el-form-item>
                    <el-form-item label="运营商模板编号" prop="templateId" :error="errors.templateId">
                        <el-input v-model="form.templateId"></el-input>
                    </el-form-item>
                    <el-form-item label="分組" prop="groupId">
                        <RemoteSelect v-model="form.groupId" :options="groups" value-name="id" label-name="name">
                        </RemoteSelect>
                    </el-form-item>
                    <el-form-item label="语言" prop="language" :error="errors.language">
                        <el-select v-model="form.language">
                            <el-option label="中文" value="中文"></el-option>
                            <el-option label="英文" value="英文"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="内容" prop="content" :error="errors.content">
                        <el-input type="textarea" v-model="form.content" :rows="5" maxlength="1000"
                            show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <div class="help-text">
                            <p>短信模板属于动态短信，根据配置的模板内容和上传的数据，自动替换占位符，并生成最终的短信内容。</p>
                            变量占位符格式为：[[name]]<br>
                            举例说明：尊敬的<strong>[[姓名]]</strong>，您的会员将于<strong>[[日期]]</strong>到期。<br>
                            <p>注意：变量个数不要超过10个，变量名称不能重复。</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status.value" :error="errors.status">
                        <el-select v-model="form.status.value">
                            <el-option label="启用" value="enable"></el-option>
                            <el-option label="禁用" value="disable"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import RemoteSelect from '@/components/RemoteSelect'

export default {
    components: {
        RemoteSelect
    },
    props: ["id", "groupId"],
    data() {
        let validateContent = (rule, value, callback) => {
            if (value === "") {
                callback(new Error('请填写模板内容'));
            } else {
                callback();
            }
        };
        return {
            form: {
                id: this.id,
                name: "",
                templateId: "",
                language: "",
                content: "",
                groupId: undefined,
                remark: "",
                status: {},
            },
            rules: {
                name: [
                    { required: true, message: "请填写模板名称" }
                ],
                // templateId: [
                //     { required: true, message: "请填写模板编号" }
                // ],
                language: [
                    { required: true, message: "请选择语言" }
                ],
                content: [
                    { required: true, validator: validateContent }
                ],
                groupId: [
                    { required: true, message: "请选择分组" }
                ],
                "status.value": [
                    { required: true, message: "请选择状态" }
                ]
            },
            errors: {},
            groups: []
        }
    },
    beforeMount() {
        if (this.form.id > 0) {
            this.$axios.get("/voice_template/get/" + this.form.id).then(result => {
                this.$utils.merge(this.form, result);
                this.loadGroup();
            })
        } else {
          this.loadGroup();
        }
    },
    methods: {
        loadGroup() {
          this.$axios.post("/group/list", {
            rules: [
              { field: "type", value: "voice" },
            ]
          }).then(data => {
            this.groups = [{ id: 0, name: "默认" }].concat(data);
            this.form.groupId = this.groupId >= 0 ? this.groupId : 0;
          });
        },
        submit() {
            let url = this.form.id > 0 ? "/voice_template/edit" : "/voice_template/save";
            this.$utils.submit(this.$refs.form, url, this.form, () => {
                this.$emit("close", true);
            }, (data) => {
                this.errors = data;
            });
        },
        close() {
            this.$emit("close", false);
        }
    }
}
</script>